<template>
  <a-form :form="form" @submit.prevent="handleSubmit">
    <a-row class="content-panle margin-0 padding-tb-0" :gutter="24">
      <a-col :span="12" class="padding-tb-md">
        <h3 class="panle-head" style="margin-bottom:16px">
          {{ $t('userCenter.miniProgSettingsTitle') }}
        </h3>
        <!-- 中文名称 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.miniprogNameCNTitle')">
            <a-input
              type="text"
              v-decorator="['companyName',
               {
                  initialValue: '',
                  rules: [
                    {
                      required: true,
                      message: $t('userCenter.miniprogNameCNBlank')
                    }
                  ]
                }]"
              :placeholder="$t('userCenter.miniprogNameCNPlacehoder')">
            </a-input>
          </a-form-item>
        </a-col>
        <!-- 英文文名称 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.miniprogNameENTitle')">
            <a-input
              type="text"
              v-decorator="['companyNameEn']"
              :placeholder="$t('userCenter.miniprogNameENPlacehoder')">
            </a-input>
          </a-form-item>
        </a-col>
        <!-- 上传 微信小程序LOGO 图片 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.miniprogLogoTitle')">
            <div class="upload-image-tip">
              {{ $t('userCenter.uploadLogoDesc') }}
            </div>
            <a-upload
              listType="picture"
              accept="image/png,image/jpg,image/gif"
              :beforeUpload="handleBeforeUploadLogoImg"
              v-decorator="[
                'wxLogoUrl',
                {
                  initialValue: [],
                  valuePropName: 'fileList',
                  getValueFromEvent: handleImageFileChange
                }
              ]"
            >
              <a-button>
                <a-icon :type="imgWxLogoUploading ? 'loading' : 'upload'"/>
                {{ $t('userCenter.uploadLogoBtn') }}
              </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
        <!-- 上传 Banner 图片 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.uploadBannerTxt')">
            <div class="upload-image-tip">
              {{ $t('userCenter.uploadBannerDesc') }}
            </div>
            <a-upload
              listType="picture"
              accept="image/png,image/jpg,image/gif"
              :beforeUpload="handleBeforeUploadImg"
              v-decorator="[
                'bannerImg',
                {
                  initialValue: [],
                  valuePropName: 'fileList',
                  getValueFromEvent: handleImageFileChange,
                  rules: [
                    {
                      required: true,
                      message: $t('userCenter.uploadBannerBlank')
                    }
                  ]
                }
              ]"
            >
              <a-button>
                <a-icon :type="imgUploading ? 'loading' : 'upload'"/>
                {{ $t('userCenter.uploadBannerBtn') }}
              </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
        <!-- 上传 企业风采 图片 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.miniprogCompanyStyleTitle')">
            <div class="upload-image-tip">
              {{ $t('userCenter.uploadCompanyStyleDesc') }}
            </div>
            <a-upload
              listType="picture"
              accept="image/png,image/jpg,image/gif"
              :beforeUpload="handleBeforeUploadCompanyStyleImg"
              v-decorator="[
                'companyStyleList',
                {
                  initialValue: [],
                  valuePropName: 'fileList',
                  getValueFromEvent: handleCompanyStyleImageChange
                }
              ]"
            >
              <a-button>
                <a-icon :type="imgCompanyStyleUploading ? 'loading' : 'upload'"/>
                {{ $t('userCenter.uploadCompanyStyleBtn') }}
              </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
        <!-- 默认授权 -->
        <a-col :span="24">
          <a-form-item>
            <a-list item-layout="horizontal" style="margin-bottom:24px">
              <a-list-item>
                <a-list-item-meta>
                <span slot="title" class="list-title">{{
                    $t('userCenter.defaultAuth')
                  }}</span>
                  <span slot="description">{{
                      $t('userCenter.defaultAuthDesc')
                    }}</span>
                </a-list-item-meta>
                <div slot="actions">

                  <a-switch
                    v-decorator="[
                    'visitorAuthed',
                    {
                      initialValue: false,
                      valuePropName: 'checked',
                    }
                  ]"
                  />
                </div>
              </a-list-item>
            </a-list>
          </a-form-item>
        </a-col>
        <!-- 仅登记主要人员 -->
        <a-col :span="24">
          <a-form-item>
            <a-list item-layout="horizontal" style="margin-bottom:24px">
              <a-list-item>
                <a-list-item-meta>
                <span slot="title" class="list-title">{{
                    $t('userCenter.miniprogOnlyMainVisitorTitle')
                  }}</span>
                  <span slot="description">{{
                      $t('userCenter.miniprogOnlyMainVisitorDesc')
                    }}</span>
                </a-list-item-meta>
                <div slot="actions">

                  <a-switch
                    v-decorator="[
                    'isOnlyMainAppointmentVisitor',
                    {
                      initialValue: false,
                      valuePropName: 'checked',
                    }
                  ]"
                  />
                </div>
              </a-list-item>
            </a-list>
          </a-form-item>
        </a-col>
        <!-- 登记显示员工姓名 -->
        <a-col :span="24">
          <a-form-item>
            <a-list item-layout="horizontal" style="margin-bottom:24px">
              <a-list-item>
                <a-list-item-meta>
                <span slot="title" class="list-title">{{
                    $t('userCenter.miniprogShowPeopleName')
                  }}</span>
                  <span slot="description">{{
                      $t('userCenter.miniprogShowPeopleNameDesc')
                    }}</span>
                </a-list-item-meta>
                <div slot="actions">

                  <a-switch
                    v-decorator="[
                    'isShowInitiatorName',
                    {
                      initialValue: false,
                      valuePropName: 'checked',
                    }
                  ]"
                  />
                </div>
              </a-list-item>
            </a-list>
          </a-form-item>
        </a-col>
        <!-- 证件是否必填 -->
        <a-col :span="24">
          <a-form-item >
            <a-list item-layout="horizontal" style="margin-bottom:24px">
              <a-list-item>
                <a-list-item-meta>
                <span slot="title" class="list-title">{{
                    $t('userCenter.visitorMustIdTxt')
                  }}</span>
                  <span slot="description">{{
                      $t('userCenter.miniprogIdNumberNotEmptyDesc')
                    }}</span>
                </a-list-item-meta>
                <div slot="actions">
                  <a-switch
                    v-decorator="[
                    'idNumberNotEmpty',
                    {
                      initialValue: false,
                      valuePropName: 'checked'
                    }
                  ]"
                  />
                </div>
              </a-list-item>
            </a-list>
          </a-form-item>
        </a-col>
        <!-- 现场照是否为空 -->
        <a-col :span="24">
          <a-form-item>
            <a-list item-layout="horizontal" style="margin-bottom:24px">
              <a-list-item>
                <a-list-item-meta>
                <span slot="title" class="list-title">{{
                    $t('userCenter.miniprogScenePhotoNotEmpty')
                  }}</span>
                  <span slot="description">{{
                      $t('userCenter.miniprogScenePhotoNotEmptyDesc')
                    }}</span>
                </a-list-item-meta>
                <div slot="actions">
                  <a-switch
                    v-decorator="[
                    'isAppointmentVisitorScenePhotoNotEmpty',
                    {
                      initialValue: false,
                      valuePropName: 'checked',
                    }
                  ]"
                  />
                </div>
              </a-list-item>
            </a-list>
          </a-form-item>
        </a-col>
<!--        是否开通短信通知-->
        <a-col :span="24">
          <a-form-item>
            <a-list item-layout="horizontal" style="margin-bottom:24px">
              <a-list-item>
                <a-list-item-meta>
                <span slot="title" class="list-title">{{
                    $t('userCenter.miniprogOpenSmsNotice')
                  }}</span>
                  <span slot="description">{{
                      $t('userCenter.miniprogOpenSmsNoticeDesc')
                    }}</span>
                </a-list-item-meta>
                <div slot="actions">
                  <a-switch
                    v-decorator="[
                    'isSendBizSms',
                    {
                      initialValue: false,
                      valuePropName: 'checked',
                    }
                  ]"
                  />
                </div>
              </a-list-item>
            </a-list>
          </a-form-item>
        </a-col>
        <a-col :span="24" style="margin-top: 16px;">
          <a-button type="primary" html-type="submit" :loading="submitting">
            {{ $t('userCenter.submitMiniProgSetBtn') }}
          </a-button>
        </a-col>
      </a-col>
      <a-col :span="12">
        <div style="display: flex">
          <QRCode
            v-if="codeString"
            :codeString="codeString"
            :logoString="wxLogoUrlSrc"
            :codeName="setQRCodeTargetFullName"
            :showDownloadBtn="true"
          >
            <template v-slot:describeBottom>
              <p style="color: #fa8c16;line-height: 1.5">
                {{ $t('userCenter.QRCodeApplyDesc') }}
              </p>
            </template>
          </QRCode>
        </div>
        <div style="display: flex">
          <QRCode
            v-if="codeH5String"
            :codeString="codeH5String"
            :logoString="wxLogoUrlSrc"
            :codeName="setQRCodeH5TargetFullName"
            :showDownloadBtn="true"
            color="#3C5F8D"
          >
            <template v-slot:describeBottom>
              <p style="color: #fa8c16;line-height: 1.5">
                {{ $t('userCenter.QRCodeH5ApplyDesc') }}
              </p>
            </template>
          </QRCode>
        </div>
      </a-col>
    </a-row>
    <WorkFlowModal
      :model-value="modelValue"
      :visible="showFeilongDesigner"
      :confirmLoading="feilongDesignerLoading"
      @submit="handleWorkFlowSubmit"
      @hideModal="() => showFeilongDesigner = false"
    />
  </a-form>
</template>

<script>
import { mapState } from 'vuex'
import { getUserConfig, setUserConfig } from '@/api/userMana'
import { uploadBase64Img } from '@/api/fileUpload'

import { compressImageFile } from '../../utils/utils'
import QRCode from '@/components/QRCode'

import WorkFlowModal from './components/WorkFlowModal'
import NavigationSettingModal from './components/NavigationSettingModal'
import { createGuideMap } from '../../api/guideMap'

export default {
  name: 'userCenterMiniprogSettings',
  components: {
    QRCode,
    WorkFlowModal,
    NavigationSettingModal
  },
  data() {
    return {
      modelValue: null,
      activeKey: '1',
      form: this.$form.createForm(this),
      imgUploading: false,
      imgWxLogoUploading: false,
      imgCompanyStyleUploading: false,
      submitting: false,
      setQRCodeTargetFullName: '小程序访问二维码',
      setQRCodeH5TargetFullName: 'H5网页端访问二维码',
      wxLogoUrlSrc: '',

      showFeilongDesigner: false,
      feilongDesignerLoading: false,
      feilongDesignerModel: null,

      propData: {
        id: 1,
        name: '请假审批',
        nodeConfig: {
          nodeName: '发起人',
          type: 0,
          nodeRoleList: [],
          childNode: {
            nodeName: '条件路由',
            type: 4,
            conditionNodes: [
              {
                nodeName: '长期',
                type: 3,
                priorityLevel: 1,
                conditionMode: 1,
                conditionList: [
                  [
                    {
                      label: '请假天数',
                      field: 'day',
                      operator: '>',
                      value: '7'
                    }
                  ]
                ],
                childNode: {
                  nodeName: '领导审批',
                  type: 1,
                  setType: 1,
                  nodeUserList: [
                    {
                      id: '360000197302144442',
                      name: '何敏'
                    }
                  ],
                  nodeRoleList: [],
                  examineLevel: 1,
                  directorLevel: 1,
                  selectMode: 1,
                  termAuto: false,
                  term: 0,
                  termMode: 1,
                  examineMode: 1,
                  directorMode: 0
                }
              },
              {
                nodeName: '短期',
                type: 3,
                priorityLevel: 2,
                conditionMode: 1,
                conditionList: [],
                childNode: {
                  nodeName: '直接主管审批',
                  type: 1,
                  setType: 2,
                  nodeUserList: [],
                  nodeRoleList: [],
                  examineLevel: 1,
                  directorLevel: 1,
                  selectMode: 1,
                  termAuto: false,
                  term: 0,
                  termMode: 1,
                  examineMode: 1,
                  directorMode: 0
                }
              }
            ],
            childNode: {
              nodeName: '抄送人',
              type: 2,
              userSelectFlag: true,
              nodeUserList: [
                {
                  id: '220000200908305857',
                  name: '何秀英'
                }
              ]
            }
          }
        }
      },

      showNavigationSetting: false,
      navigationSettingLoading: false,
      navigationSettingModel: null,
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      appointmentVisitorValidType: state =>
        state.enumsStore.enumsData.appointmentVisitorValidType
      ,
      codeString: state => process.env.VUE_APP_BASE_QRCODE_URL + '?id=' + state.userInfo.id || '',
      codeH5String: state => process.env.VUE_APP_BASE_QRCODE_H5_URL + '?userId=' + state.userInfo.id || '',
    })
  },
  created() {
    this.getSettings()
  },
  deactivated() {
    // this.form.resetFields()
  },
  methods: {
    // 获取设置
    async getSettings() {
      let _this = this
      try {
        const res = await getUserConfig()
        const {
          wxLogoUrl,
          companyName,
          companyNameEn,
          wxPersonBannerUrl,
          promotePhotoUrls,
          isAppointmentVisitorCreateAuth,
          isAppointmentVisitorIdNumberNotEmpty,
          isAppointmentVisitorScenePhotoNotEmpty,
          isOnlyMainAppointmentVisitor,
          isShowInitiatorName,
          isSendBizSms
        } = res.data.collection[0]
        _this.settings = res.data.collection[0]
        // 设置默认 LOGO 图片
        const logoImages = []
        if (wxLogoUrl) {
          logoImages.push({
            uid: wxLogoUrl,
            name: this.lang === 'zh_CN' ? '小程序LOGO' : 'Mini Program LOGO',
            status: 'done',
            url: wxLogoUrl,
            thumbUrl: wxLogoUrl
          })
          this.wxLogoUrlSrc = wxLogoUrl
        }
        // 设置默认 Banner 图片
        const defaultImg = []
        if (wxPersonBannerUrl) {
          defaultImg.push({
            uid: wxPersonBannerUrl,
            name: this.lang === 'zh_CN' ? '默认 Banner' : 'Default Banner',
            status: 'done',
            url: wxPersonBannerUrl,
            thumbUrl: wxPersonBannerUrl
          })
        }
        //设置企业风采
        let companyStyleImages = []
        let promotePhotoUrlList = JSON.parse(promotePhotoUrls)
        if (promotePhotoUrlList && promotePhotoUrlList.length > 0) {
          promotePhotoUrlList.forEach((item) => {
            companyStyleImages.push({
              uid: item,
              name: this.lang === 'zh_CN' ? '企业风采' : 'Company Style',
              status: 'done',
              url: item,
              thumbUrl: item
            })
          })
        }
        // 修改 form 初始值
        _this.$nextTick(() => {
          this.form.setFieldsValue({
            companyName: companyName,
            companyNameEn: companyNameEn,
            wxLogoUrl: logoImages,
            bannerImg: defaultImg,
            visitorValidType: '3',
            companyStyleList: companyStyleImages,
            isOnlyMainAppointmentVisitor: isOnlyMainAppointmentVisitor === 'true',
            idNumberNotEmpty: isAppointmentVisitorIdNumberNotEmpty || 'false',
            isSendBizSms: isSendBizSms == 'true' || false,
            visitorAuthed: isAppointmentVisitorCreateAuth === 'true',
            isShowInitiatorName: isShowInitiatorName === 'true',
            isAppointmentVisitorScenePhotoNotEmpty: isAppointmentVisitorScenePhotoNotEmpty === 'true',
          })
        })
      } catch (error) {
      }
    },
    // 提交设置
    handleSubmit() {
      let _this = this
      this.form.validateFields(async (err, values) => {
        // console.log('-----handleSubmit err-----', err)
        // console.log('-----handleSubmit values-----', values)
        if (!err) {
          try {
            this.submitting = true
            // setUserConfig 不能并发提交，不然可能会导致某些修改失效
            //中文名称
            if (_this.settings && _this.settings.companyName !== values.companyName) {
              await setUserConfig({
                key: 'companyName',
                value: values.companyName
              })
            }
            //英文名称
            if (_this.settings && _this.settings.companyNameEn !== values.companyNameEn) {
              await setUserConfig({
                key: 'companyNameEn',
                value: values.companyNameEn
              })
            }
            //logo图片
            if (_this.settings && _this.settings.wxLogoUrl !== values.wxLogoUrl) {
              await setUserConfig({
                key: 'wxLogoUrl',
                value: values.wxLogoUrl[0].url
              })
            }
            //企业风采
            let companyStyleList = []
            values.companyStyleList.forEach((item) => {
              companyStyleList.push(item.url)
            })
            let promotePhotoUrls = JSON.stringify(companyStyleList)
            // console.log(_this.settings , promotePhotoUrls)
            if (_this.settings && _this.settings.promotePhotoUrls !== promotePhotoUrls) {
              await setUserConfig({
                key: 'promotePhotoUrls',
                value: promotePhotoUrls
              })
            }
            //banner
            await setUserConfig({
              key: 'wxPersonBannerUrl',
              value: values.bannerImg[0].url
            })
            await setUserConfig({
              key: 'appointmentVisitorValidType',
              value: '3'
              // value: values.visitorValidType
            })
            await setUserConfig({
              key: 'isAppointmentVisitorCreateAuth',
              value: values.visitorAuthed.toString()
            })
            await setUserConfig({
              key: 'isOnlyMainAppointmentVisitor',
              value: values.isOnlyMainAppointmentVisitor
            })
            await setUserConfig({
              key: 'isAppointmentVisitorIdNumberNotEmpty',
              value: values.idNumberNotEmpty
            })
            await setUserConfig({
              key: 'isSendBizSms',
              value: values.isSendBizSms
            })
            await setUserConfig({
              key: 'isAppointmentVisitorScenePhotoNotEmpty',
              value: values.isAppointmentVisitorScenePhotoNotEmpty
            })
            await setUserConfig({
              key: 'isShowInitiatorName',
              value: values.isShowInitiatorName
            })
            this.submitting = false
            this.$notification.success({
              message: this.$t('userCenter.setMiniprogSettingsSuccess'),
              description: ''
            })
          } catch (error) {
            this.submitting = false
          }
        }
      })
    },
    // 提交图片前，验证图片大小和宽高，不符合就进行图片压缩
    async handleBeforeUploadImg(file) {
      // console.log('--handleBeforeUploadImg--', file)
      // 若是 gif 则不压缩
      let options = file.type === 'image/gif' ? { maxSize: null } : {
        maxSize: 200,
        fixedW: 375,
        fixedH: 200
      }
      compressImageFile(file, options, this.handleUploadBannerImg)
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject()
    },

    // 提交图片前，验证图片大小和宽高，不符合就进行图片压缩
    async handleBeforeUploadLogoImg(file) {
      let options = file.type === 'image/gif' ? { maxSize: null } : {
        maxSize: 400,
        fixedW: 144,
        fixedH: 144
      }
      compressImageFile(file, options, this.handleUploadWxLogoImg)
      return Promise.reject()
    },
    // 提交图片前，验证图片大小和宽高，不符合就进行图片压缩
    async handleBeforeUploadCompanyStyleImg(file) {
      let options = file.type === 'image/gif' ? { maxSize: null } : { maxSize: 1024 }
      compressImageFile(file, options, this.handleUploadCompanyStyleImg)
      return Promise.reject()
    },

    // 上传 Banner 图片
    async handleUploadBannerImg(image) {
      try {
        this.imgUploading = true
        const base64Unhead = image.base64.replace(
          /^data:image\/\w+;base64,/,
          ''
        )
        const type = image.type.replace('image/', '')
        const res = await uploadBase64Img({
          data: base64Unhead,
          suffix: type
        })
        this.imgUploading = false
        this.$message.success(
          `${image.name} ${this.$t('userCenter.uploadSuccess')}`
        )

        this.form.setFieldsValue({
          bannerImg: [{
            ...image,
            url: res.data.collection[0]
          }]
        })
      } catch (error) {
        this.$message.error(`${image.name} ${this.$t('userCenter.uploadFail')}`)
        this.imgUploading = false
      }
    },
    handleImageFileChange(file) {
      // console.log('--handleImageFileChange--', file)
      if (file.file.status === 'removed') {
        return []
      }
      return file.fileList
    },

    // 上传 企业风采 图片
    async handleUploadCompanyStyleImg(image) {
      try {
        this.imgCompanyStyleUploading = true
        const base64Unhead = image.base64.replace(
          /^data:image\/\w+;base64,/,
          ''
        )
        const type = image.type.replace('image/', '')
        const res = await uploadBase64Img({
          data: base64Unhead,
          suffix: type
        })
        this.imgCompanyStyleUploading = false
        this.$message.success(
          `${image.name} ${this.$t('userCenter.uploadSuccess')}`
        )
        let fieldsValue = this.form.getFieldsValue(['companyStyleList'])
        let values = fieldsValue['companyStyleList']
        console.log(values)
        values.push({
          ...image,
          url: res.data.collection[0]
        })
        console.log(values)
        this.form.setFieldsValue({ companyStyleList: values })
      } catch (error) {
        this.$message.error(`${image.name} ${this.$t('userCenter.uploadFail')}`)
        this.imgCompanyStyleUploading = false
      }
    },
    // 上传 企业风采 图片
    async handleUploadGuideMapImg(image) {
      try {
        this.imgCompanyStyleUploading = true
        const base64Unhead = image.base64.replace(
          /^data:image\/\w+;base64,/,
          ''
        )
        const type = image.type.replace('image/', '')
        const res = await uploadBase64Img({
          data: base64Unhead,
          suffix: type
        })
        this.imgCompanyStyleUploading = false
        this.$message.success(
          `${image.name} ${this.$t('userCenter.uploadSuccess')}`
        )
        let fieldsValue = this.form.getFieldsValue(['guideMapList'])
        let values = fieldsValue['guideMapList']
        values.push({
          ...image,
          url: res.data.collection[0]
        })

        const res2 = await createGuideMap({
          photoName: '引导图',
          photoUrl: res.data.collection[0]
        })
        console.log(values)
        this.form.setFieldsValue({ guideMapList: values })
      } catch (error) {
        this.$message.error(`${image.name} ${this.$t('userCenter.uploadFail')}`)
        this.imgCompanyStyleUploading = false
      }
    },
    handleCompanyStyleImageChange(file) {
      console.log('--handleImageFileChange--', file)
      let f = file.file
      let fileList = file.fileList
      if (f.status === 'removed') {
        fileList.forEach((item, index) => {
          if (item.url === f.url) {
            fileList.delete(index)
          }
        })
      }
      return fileList
    },

    // 上传 企业风采 图片
    async handleUploadWxLogoImg(image) {
      try {
        this.imgWxLogoUploading = true
        const base64Unhead = image.base64.replace(
          /^data:image\/\w+;base64,/,
          ''
        )
        const type = image.type.replace('image/', '')
        const res = await uploadBase64Img({
          data: base64Unhead,
          suffix: type
        })
        this.imgWxLogoUploading = false
        this.$message.success(
          `${image.name} ${this.$t('userCenter.uploadSuccess')}`
        )
        let logoUrl = res.data.collection[0]
        this.wxLogoUrlSrc = logoUrl
        this.form.setFieldsValue({
          wxLogoUrl: [{
            ...image,
            url: logoUrl
          }]
        })
      } catch (error) {
        this.$message.error(`${image.name} ${this.$t('userCenter.uploadFail')}`)
        this.imgWxLogoUploading = false
      }
    },
    tabChange(key) {
      this.activeKey = key
    },
    handleWorkFlowSubmit(data) {
    },
    handleFlowDesignerShow() {
      this.modelValue = this.propData
      this.showFeilongDesigner = true
    },
    handleFlowDesiginerHide() {
    },
    handleNavigationSettingShow() {
      this.showNavigationSetting = true
    },
  }
}
</script>

<style scoped>
.upload-image-tip {
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 5px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
